import React from 'react'
import { Provider } from 'mobx-react'

import SearchListings from './SearchListings'
import ListingsStore from './stores/ListingsStore'

import { transport, channel, sessionStorage, history } from '../../../lib/services'
import { eventBus } from '../../../lib/utils/dom'

const store = new ListingsStore({
  transport,
  channel,
  eventBus,
  sessionStorage,
  history
})

const StatefulSearchListings = props => {
  return (
    <Provider store={store}>
      <SearchListings {...props} />
    </Provider>
  )}

export default StatefulSearchListings
